import { render, staticRenderFns } from "./PaketList.vue?vue&type=template&id=3859fc63&scoped=true"
import script from "./PaketList.vue?vue&type=script&lang=js"
export * from "./PaketList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3859fc63",
  null
  
)

export default component.exports